import { OptionGroup } from './OptionGroup';
export type { IOptionGroup } from './OptionGroup.types';
export default OptionGroup;
